import { render, staticRenderFns } from "./aboutWhy.vue?vue&type=template&id=541dca26&scoped=true&"
import script from "./aboutWhy.vue?vue&type=script&lang=js&"
export * from "./aboutWhy.vue?vue&type=script&lang=js&"
import style0 from "./aboutWhy.vue?vue&type=style&index=0&id=541dca26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541dca26",
  null
  
)

export default component.exports